<template>
    <el-dialog
            title="" class="downTipDialog"
            :visible.sync="dialogVisible"
            width="50%" append-to-body>
        <div class="text-center">
            <div class="title">打包下载注意事项，很重要！</div>
            <div class="title-tip">请仔细阅读以下注意事项，避免重复下载或下载中断</div>

        </div>
        <div class="content-view">
            <div>1.提前检查硬盘空间是否够用：空间不足可能导致下载失败</div>
            <div>2.检查网络状况：企业内网、学校网络限速等可能会导致耗时太久或下载中断</div>
            <div>3.如果下载中断，在浏览器下载记录里，右键选择“继续下载”即可，不要点“取消”</div>
            <div>4.命名时不要选择内容长或含有特殊字符的项目，受电脑文件名限制，导致部分电脑下载后打不开</div>
            <div>5.平台不限速，打包需要10分钟左右：根据文件数量，命名复杂度时间会有差异</div>
            <div>6.更多常见问题：<a href="https://help.pfotoo.com/?p=647"
                             style="color: #576B95;"
                             target="_blank">点我查看更多常见问题</a></div>
        </div>
        <div @click="iknow" class="bg-green round button-iknow flex align-center justify-center tap">我知道了</div>
    </el-dialog>
</template>
<script>
  import App from '../../util/comfun'
  export default {
    props:{

    },
    data () {
      return {
        dialogVisible: true,
      }
    },
    methods:{
      handleClose(){

      },
      iknow(){
        this.dialogVisible=false
      },
    },
    mounted(){

    },

  }
</script>

<style>
    .downTipDialog{
        .el-dialog{
            border-radius: 30px;
            background: #FFFFFF;
        }
        .title{
            font-family: PingFang SC;
            font-size: 20px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0px;

            /* 主题色/红色 */
            /* 样式描述：错误失败 */
            color: #E0605A;
        }
        .title-tip{
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0px;

            color: #999999;
            margin-top: 10px;
        }
        .content-view{
            margin-top: 40px;
            background: #EFF0F1;
            padding: 20px;
            font-family: PingFang SC;
            font-size: 14px;
            font-weight: 500;
            line-height: normal;
            letter-spacing: 0px;

            font-variation-settings: "opsz" auto;
            z-index: 0;
            color: #5D5D5D;
            div{
                margin-bottom: 10px;
            }
        }
        .button-iknow{
            margin: 60px auto;
            width: 170px;
            height: 40px;
            border-radius: 30px;

            font-family: PingFang SC;
            font-size: 16px;
            font-weight: normal;
            line-height: 22px;
            letter-spacing: 0px;

            color: #FFFFFF;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/components/downTipDialog.vue